// extracted by mini-css-extract-plugin
export default {"svgIcon":"c-a_j","svgIcon_withoutFill":"c-a_k","svgIcon_withoutStroke":"c-a_l"};